import { render } from "./invoiceSettings.vue?vue&type=template&id=01035d5d&scoped=true&ts=true"
import script from "./invoiceSettings.vue?vue&type=script&lang=ts"
export * from "./invoiceSettings.vue?vue&type=script&lang=ts"

import "./invoiceSettings.vue?vue&type=style&index=0&id=01035d5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01035d5d"]])

export default __exports__